export const namespaced = true
import EventService from '@/services/EventService.js'
import _clone from 'lodash/cloneDeep'
import { getLeadersText } from '@/utils/common'

export const state = {
  events: [],
  eventsMap: {},
  loadingEvents: false,
  openCalendarDialog: false,
  openNotificationDialog: false,
  savingEvent: false,
  showEventForm: false,
  selectedEvent: {},
  selectedIndex: null,
  notificationEvents: [],
  showNotification: false
}

export const mutations = {
  SET_EVENTS(state, list) {
    state.events = list
    state.eventsMap = list.reduce(function(map, obj) {
      map[obj.id] = obj
      return map
    }, {})
  },
  SET_NOTIFICATION_EVENTS(state, list) {
    state.notificationEvents = list
  },
  SET_SHOW_NOTIFICATION(state, val) {
    state.showNotification = val
  },
  SET_EVENTS_LOADING(state, val) {
    state.loadingEvents = val
  },
  SET_SHOW_EVENT_FORM(state, val) {
    state.showEventForm = val
  },
  UPDATE_EVENT(state, event) {
    state.events = [
      ...state.events.slice(0, state.selectedIndex),
      event,
      ...state.events.slice(state.selectedIndex + 1)
    ]
    state.eventsMap = { ...state.eventsMap, [event.id]: event }
  },
  REMOVE_EVENT(state, index) {
    state.events.splice(index, 1)
  },
  SET_OPEN_CALENDAR_DIALOG(state, val) {
    state.openCalendarDialog = val
  },
  SET_OPEN_NOTIFICATION_DIALOG(state, val) {
    state.openNotificationDialog = val
  },
  ADD_EVENT(state, event) {
    state.events.unshift(event)
    state.eventsMap = { ...state.eventsMap, [event.id]: event }
  },
  SET_SAVING_EVENT(state, val) {
    state.savingEvent = val
  },
  SET_SELECTED_EVENT(state, val) {
    state.selectedEvent = val
  },
  SET_SELECTED_INDEX(state, val) {
    state.selectedIndex = val
  }
}

export const actions = {
  openCalendarDialog({ commit }, open) {
    commit('SET_OPEN_CALENDAR_DIALOG', open)
  },
  openNotificationDialog({ commit }, open) {
    commit('SET_OPEN_NOTIFICATION_DIALOG', open)
  },
  showNotification({ commit }, show) {
    commit('SET_SHOW_NOTIFICATION', show)
  },
  fetchEvents({ commit }, leadersMap) {
    commit('SET_EVENTS_LOADING', true)
    commit('SET_EVENTS', [])
    EventService.getEvents()
      .then(querySnapshot => {
        let items = querySnapshot.docs.map(doc => {
          let item = doc.data()
          item.id = doc.id
          item.leadersHtml = getLeadersText(item.leaders, leadersMap)
          item.leadersText = item.leadersHtml.replaceAll('<br/>', ', ')
          return item
        })
        commit('SET_EVENTS', items)
        commit('SET_EVENTS_LOADING', false)
      })
      .catch(error => {
        console.error("Couldn't get events", error)
      })
  },
  addEvent({ commit }, { event, leadersMap }) {
    commit('SET_SAVING_EVENT', true)
    event.createdAt = new Date().getTime()
    event.updatedAt = new Date().getTime()
    event.endTime = event.endTime.trim()
    event.startTime = event.startTime.trim()
    event.start = event.startDate + ' ' + event.startTime
    event.end = event.endDate + ' ' + event.endTime
    event.timestamp = new Date(event.start).getTime()
    EventService.pushEvent(event)
      .then(doc => {
        var item = _clone(event)
        item.id = doc.id
        item.leadersHtml = getLeadersText(item.leaders, leadersMap)
        item.leadersText = item.leadersHtml.replaceAll('<br/>', ', ')

        commit('ADD_EVENT', item)
        commit('SET_SAVING_EVENT', false)
        commit('SET_SHOW_EVENT_FORM', false)
      })
      .catch(error => {
        console.error('Error saving event: ', error)
        commit('SET_SAVING_EVENT', false)
      })
  },
  updateEvent({ commit }, { event, leadersMap }) {
    commit('SET_SAVING_EVENT', true)
    event.updatedAt = new Date().getTime()
    event.endTime = event.endTime.trim()
    event.startTime = event.startTime.trim()
    event.start = event.startDate + ' ' + event.startTime
    event.end = event.endDate + ' ' + event.endTime
    event.timestamp = new Date(event.start).getTime()
    var eventToUpdate = _clone(event)
    delete eventToUpdate.leadersHtml
    delete eventToUpdate.leadersText

    EventService.updateEvent(eventToUpdate)
      .then(() => {
        var item = _clone(event)
        item.leadersHtml = getLeadersText(item.leaders, leadersMap)
        item.leadersText = item.leadersHtml.replaceAll('<br/>', ', ')
        console.info('Success event update')
        commit('UPDATE_EVENT', item)
        commit('SET_SELECTED_EVENT', item)
        commit('SET_SAVING_EVENT', false)
        commit('SET_SHOW_EVENT_FORM', false)
      })
      .catch(error => {
        console.error('Error updating event: ', error)
        commit('SET_SAVING_EVENT', false)
      })
  },
  deleteEvent({ dispatch }, event) {
    EventService.deleteEvent(event)
      .then(() => {
        console.info('Success delete event')
        dispatch('fetchEvents')
      })
      .catch(error => {
        console.error('Error removing document: ', error)
      })
  },
  selectEvent({ commit, getters }, event) {
    var index = getters.getEvents().indexOf(event)
    commit('SET_SELECTED_EVENT', event)
    commit('SET_SELECTED_INDEX', index)
  },
  showEventForm({ commit }, val) {
    commit('SET_SHOW_EVENT_FORM', val)
  },
  fetchNotificationEvents({ commit }, leadersMap) {
    commit('SET_NOTIFICATION_EVENTS', [])
    EventService.getNotificationEvents()
      .then(querySnapshot => {
        let items = querySnapshot.docs.map(doc => {
          let item = doc.data()
          item.id = doc.id
          item.leadersHtml = getLeadersText(item.leaders, leadersMap)
          return item
        })
        commit('SET_NOTIFICATION_EVENTS', items)
      })
      .catch(error => {
        console.error("Couldn't get notification events", error)
      })
  }
}

export const getters = {
  getEventById: state => id => {
    return state.events.find(event => event.id === id)
  },
  getOpenProfileDialog: state => () => {
    return state.openProfileDialog
  },
  getDirtyEvents: state => () => {
    return state.dirtyEvents
  },
  getDirtyFilters: state => () => {
    return state.dirtyFilters
  },
  getEvents: state => () => {
    return state.events
  },
  getUnfilteredEvents: state => () => {
    return state.unfilteredEvents
  }
}
